import { useNowTicker as useNowTickerBase } from '@src/packages/utils/hooks/useNowTicker';

import { STATUS_TICK_INTERVAL_MS } from '../constants';

/** @see useNowTicker in `@src/packages/utils/hooks/useNowTicker` */
export const useNowTicker = (intervalMs: number = STATUS_TICK_INTERVAL_MS): number =>
  useNowTickerBase(intervalMs);
